<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs11, sm10, md10, lg9)
          v-card(flat)
            breadcrumb(back='page4-2')
            v-card-text.text-xs-center.label16tt.withDivider(style='margin-top:-58px;')
              | LECCIÓN: ELIGE TU CRÉDITO HIPOTECARIO
            v-card-text.titulo36Book.text-xs-center
              | ¡Quiero elegir la mejor condición para contratar mi Crédito Hipotecario!
            v-layout(row, justify-start)
              v-flex.ml-0.pl-0(xs12)
                v-card(flat, text-xs-start)
                  v-card-media(height='522px', src='assets/TCH-L2.5-Infografia_Crop.jpeg')
                  v-layout(row, justify-right)
                    v-flex(text-xs-right)
                      v-btn.white--text.infographic_btn.text-xs-right(color='grey darken-2', @click.prevent='dialog=true')
                        v-icon.pr-2 fas fa-expand
                        | Expandir
            v-card-text.parrafoDestacado18
              | Ahora sabes qué tipo de Crédito Hipotecario necesitas (compra de vivienda, terreno, etc.). 
              |  También sabes que al adquirir tu Crédito Hipotecario contratas un conjunto de seguros que te 
              |  protegen de imprevistos. Ahora vas a diseñar el plan de financiamiento que más te conviene. 
              |  ¡Revisa el siguiente infográfico para aprender sobre aspectos y variables primordiales que influyen 
              |  en tu plan de Crédito.!
            v-layout(row, justify-center)
              v-btn.btn(justify-space-between, type='button', color='primary', @click.prevent="nextPage('page6-1')")
                | Siguiente
          l-progress(:value='this.$parent.currentPage')
        v-dialog(v-model='dialog', attach='#attachDialog', scrollable, max-width="1024")
          v-card(tile)
            v-layout(justify-right)
              v-flex(text-xs-right)
                v-btn.infographic_btn_close.white--text.text-xs-right(color='grey darken-2', @click.prevent='dialog=false')
                  v-icon.pr-2 fas fa-compress
                  | Cerrar
            v-card-text
              v-layout(justify-center wrap)
                div(style="margin-bottom:-10px;")
                  img(src='assets/IMG1-INFO.jpg' width='100%')
                a(href="https://www.bancomer.com/personas/educacion-financiera/-que-son-los-gastos-de-originacion-.html" target="_blank" style="margin-bottom:-10px;")
                  img(src='assets/IMG2-INFO.jpg' width="100%")               
                div(style="margin-bottom:-10px;")
                  img(src='assets/IMG3-INFO.jpg' width="100%")
                a(href="https://www.bancomer.com/personas/educacion-financiera/-que-es-un-credito-mancomunado-.html" target="_blank" style="margin-bottom:-10px;")
                  img(src='assets/IMG4-INFO.jpg' width="100%")
                div(style="margin-bottom:-10px;")
                  img(src='assets/IMG5-INFO.jpg' width="100%") 
                a(href="https://www.bancomer.com/personas/educacion-financiera/que-es-el-cofinanciamiento.html" target="_blank" style="margin-bottom:-10px;")
                  img(src='assets/IMG6-INFO.jpg' width="100%")
                div(style="margin-bottom:-10px;")
                  img(src='assets/IMG7-INFO.jpg' width="100%")
</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      progress: false,
      dialog: false
    }
  },
  methods: {
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    nextChapter(page) {
      this.progress = true;
      eventBus.$emit('next_chapter', page);
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    }
  }
};
</script>
